(() => {
    // going from index 0, searches after and equals 3
    let autocompleteBox = document.querySelector('.autocomplete--box');
    let liSelected;
    let index = -1;

    const initStateReady = () => {
        // event listener
        if (autocompleteBox) {
            document.addEventListener('keydown', function (event) {
                accessibilityKeyNavigation(event);
            });
        }
    };

    /**
     * navigate through list using arrow keys
     * @param event
     */
    const accessibilityKeyNavigation = (event) => {
        let len = autocompleteBox.getElementsByTagName('li').length - 1;
        let next;

        if (event.key === 'Enter') {
            // set value and submit
            setCurrentValueToSearchField();
        } else if (event.key === 'ArrowUp') {
            if (liSelected) {
                removeClass(liSelected, 'selected');
                index--;
                next = autocompleteBox.getElementsByTagName('li')[index];

                if (typeof next !== undefined && index >= 0) {
                    liSelected = next;
                } else {
                    index = len;
                    liSelected = autocompleteBox.getElementsByTagName('li')[len];
                }

                addClass(liSelected, 'selected');
            } else {
                index = 0;
                liSelected = autocompleteBox.getElementsByTagName('li')[len];
                addClass(liSelected, 'selected');
            }
        } else if (event.key === 'ArrowDown') {
            index++;

            if (liSelected) {
                removeClass(liSelected, 'selected');
                next = autocompleteBox.getElementsByTagName('li')[index];

                if (typeof next !== undefined && index <= len) {
                    liSelected = next;
                } else {
                    index = 0;
                    liSelected = autocompleteBox.getElementsByTagName('li')[0];
                }

                addClass(liSelected, 'selected');
            } else {
                index = 0;
                liSelected = autocompleteBox.getElementsByTagName('li')[0];
                addClass(liSelected, 'selected');
            }
        }
    };

    const removeClass = (el, className) => {
        if (el.classList) {
            el.classList.remove(className);
        } else {
            el.className = el.className.replace(
                new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
                ' '
            );
        }
    };

    const addClass = (el, className) => {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += ' ' + className;
        }
    };

    const setCurrentValueToSearchField = () => {
        if (liSelected) {
            document.querySelector('#searchFormField').value = liSelected.textContent;
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
